import { firestore } from '../utilities/firebase'
import { errorOfType, errorTypes } from '../utilities/Errors'

const setUserProfileFollower = async ({ uid, isFollowing, follower }) => {
	try {
		if (uid === follower.uid) {
			return Promise.reject(errorOfType(errorTypes.INVALIDOBJECT, uid, 'cannot follow yourself'))
		}
		const ref = firestore.collection('userProfiles').doc(uid).collection('followers').doc(follower.uid)
		return (isFollowing ? ref.set(follower) : ref.delete())
	} catch (exception) {
		throw errorOfType(errorTypes.UNKNOWNERROR, exception)
	}
}
export default setUserProfileFollower



// WEBPACK FOOTER //
// ./src/dataservices/setUserProfileFollower.js